const replaceCsvRestrictedSymbols = (string = '') => string
  .replaceAll(',', ' ')
  .replaceAll('"', ' ')
  .replaceAll(';', ' ');

export default replaceCsvRestrictedSymbols;
